import * as yup from 'yup'

import { Button, Form } from 'react-bootstrap'
import React, { useRef } from 'react'

import { ButtonContainer } from '../index.style'
import { Formik } from 'formik'
import Swal from 'sweetalert2'
import TextField from './FormFields/TextField'

const FormUpdateHighlightLottery = ({ handleSubmitForm, defaultValues, isLoading }) => {
  const formRef = useRef()

  const schema = yup.object().shape({
    id: yup.string().required(),
    remark: yup.string(),
  })

  const handleClickClearConfig = () => {
    Swal.fire({
      icon: 'info',
      title: 'ต้องการล้างการตั้งค่าหรือไม่',
      text: 'การตั้งค่าทั้งหมดจะถูกล้าง',
      showCancelButton: true,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          formRef.current.resetForm()
          Swal.fire({
            icon: 'success',
            title: 'ล้างการตั้งค่าสำเร็จ',
          })
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: error.message,
          })
        }
      }
    })
  }

  const handleClickSubmit = () => {
    Swal.fire({
      icon: 'info',
      title: 'ต้องการลบการตั้งค่าหรือไม่',
      showCancelButton: true,
      confirmButtonText: 'บันทึก',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          handleSubmitForm(formRef.current.values)
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: error.message,
          })
        }
      }
    })
  }

  return (
    <Formik
      innerRef={(f) => (formRef.current = f)}
      enableReinitialize
      validationSchema={schema}
      onSubmit={handleClickSubmit}
      initialValues={{
        id: defaultValues.id,
        remark: '',
      }}
    >
      {({ handleSubmit, resetForm }) => (
        <Form onSubmit={handleSubmit}>
          <TextField label="รายละเอียด" placeholder="รายละเอียด" name="remark" />
          <ButtonContainer>
            <Button variant="danger" onClick={handleClickClearConfig} disabled={isLoading}>
              ล้างการตั้งค่า
            </Button>
            <Button type="submit" disabled={isLoading}>
              {isLoading ? 'Loading…' : 'บันทึก'}
            </Button>
          </ButtonContainer>
        </Form>
      )}
    </Formik>
  )
}

export default FormUpdateHighlightLottery
